<template>
	<div>
		<van-form style="padding-bottom: 50px;">
			<van-field
				v-model="process_id_text"
				label="流程"
				placeholder="选择流程"
				readonly
				@click="popup.process = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择出差流程' }]"
			/>
			<van-field
				v-model="form.xmmc"
				label="项目名称"
				placeholder="输入项目名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入项目名称' }]"
			/>
			<!-- <van-field
				v-model="form.hxsj"
				label="花销时间"
				placeholder="输入花销时间"
				:rules="[{ required: true, trigger: 'onBlur', message: '输入花销时间' }]"
			/> -->
			<van-field
				v-model="form.hxsj"
				name="花销时间"
				label="花销时间"
				placeholder="选择花销时间"
				readonly
				@click="popup.calendar = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择花销时间' }]"
			/>
			<van-field
				v-model="bxlx_text"
				name="报销类型"
				label="报销类型"
				placeholder="选择报销类型"
				readonly
				@click="popup.bxlx = true"
				:rules="[{ required: true, trigger: ' onBlur', message: '请选择报销类型' }]"
			/>
			<van-field
				v-model="form.bxsm"
				label="报销说明"
				placeholder="输入报销说明"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入报销说明' }]"
			/>
			<van-field
				v-model="form.je"
				label="金额"
				placeholder="输入金额"
				type="numbner"
				:rules="[{ required: true, trigger: 'onBlur', message: '请输入金额' }]"
			/>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader
						v-model="uploader"
						:max-count="6"
						accept="all"
					/>
				</template>
			</van-field>
			<div style="margin: 16px;">
				<van-button round block type="info" @click="onSubmit" native-type="submit">提交</van-button>
			</div>
		</van-form>

		<van-calendar v-model="popup.calendar" @confirm="confirmCalendar" />
		<van-popup v-model="popup.process" position="bottom">
			<van-picker
				show-toolbar
				:columns="processList"
				@cancel="popup.process = false"
				@confirm="confirmProcess"
				value-key="process_name"
			/>
		</van-popup>
		<van-popup v-model="popup.bxlx" position="bottom">
			<van-picker
				show-toolbar
				:columns="bxlxList"
				@cancel="popup.bxlx = false"
				@confirm="confirmbxlx"
			/>
		</van-popup>
		<van-overlay :show="!signTime">
			<div class="wrapper">
				<van-loading size="24px">文件上传中,请稍后...</van-loading>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import { getNowFormatDate } from "@/utils/tool";
import { getList } from "@/api/review";
import { Toast } from "vant";
import axios from "axios";
import { getToken } from "@/utils/auth";

export default {
	name: "purchase",
	data() {
		return {
			uploader: [],
			type_id: this.$route.query.type,
			process_id: "",
			process_id_text: "",
			bxlx_text: "",
			form: {
				xmmc: "",
				hxsj: "",
				bxsm: "",
				bxlx: "",
				je: ""
			},
			processList: [],
			popup: {
				process: false,
				calendar: false,
				bxlx: false
			},
			bxlxList: [
				{ text: "交通", id: 0 },
				{ text: "住宿", id: 1 },
				{ text: "餐饮", id: 2 },
				{ text: "其他", id: 3 }
			],
			signTime: true
		};
	},
	mounted() {
		this.getPurchaseList();
	},
	methods: {
		onSubmit() {
			let that = this;
			let formData = new FormData();
			for (let i = 0; i < this.uploader.length; i++) {
				formData.append("file", this.uploader[i].file);
			}
			formData.append("process_id", this.process_id);
			formData.append("requestType", "process_apply");
			formData.append("apply_data",JSON.stringify(this.form));
			formData.append("apply_rmb",  this.form.je);
			formData.append("token", getToken());

			const config = {
				timeout: 60 * 1000,
				headers: {
					"Content-Type": "multipart/form-data",
				},
			};

			this.signTime = false;

			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => {
					console.log(res);
					if (res.data.code === 200) {
						this.$route.params.listRefresh = true;
						this.$router.go(-1);
						Toast.fail("提交成功!");
					} else if (res.data.code === 300) {
						this.$router.push({
							path: "/login",
						});
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((err) => {
					console.log(err);
					that.signTime = true;
					let text = "当前网络环境差,请重新提交!";
					this.$toast.fail(text);
				});
		},
		confirmCalendar(value) {
			this.form.hxsj = getNowFormatDate(value);
			this.popup.calendar = false;
		},
		getPurchaseList() {
			getList({
				requestType: "process_type",
				type_id: this.type_id
			})
				.then(res => {
					this.processList = res.obj;
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		},
		clearForm() {
			for (var key in this.form) {
				if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.process_id_text = "";
			this.process_id = "";
			this.bxlx_text = "";
		},
		confirmProcess(value) {
			this.process_id_text = value.process_name;
			this.process_id = value.process_id;
			this.popup.process = false;
		},
		confirmbxlx(value) {
			this.bxlx_text = value.text;
			this.form.bxlx = value.id;
			this.popup.bxlx = false;
		}
	}
};
</script>